import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getProductReviewApi = createAsyncThunk("client/get-review-list", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}vancouverapis/webapp/product-reviews/api/v1/get-review-list`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });
    console.log("product  re response", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products r:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
  }
});

// Update product review
export const updateProductReviewApi = createAsyncThunk("client/update-review", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.put(`${baseUrl}vancouverapis/webapp/product-reviews/api/v1/update-review/${data.rowId}`, data, {
      headers: {
        "auth-token": token,
        // "Content-Type": "application/json",
      },
    });
    console.log("product response", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products r:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
  }
});
